const youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:embed\/)?(?:watch\?v=)?(?!results|c\/)([^ ,.:;<>(){}\[\]\n&?]+)/i;

export default youtubePattern;